/** Merged Vietnamese Near Me copy (flagship wave 1 + wave 2). */
import { NEAR_VI_COPY, type NearViCopy } from "./vi-copy";
import { NEAR_VI2_COPY } from "./vi-copy-2";
import type { NearViAnyKey } from "./vi-keys";

export const NEAR_VI_ALL_COPY: Record<NearViAnyKey, NearViCopy> = {
  ...NEAR_VI_COPY,
  ...NEAR_VI2_COPY,
};
